import {Component, OnInit} from '@angular/core';
import {CoinModelSendSignal} from "../../../../_models/send-signal";
import {DialogComponent, DialogService} from "ng2-bootstrap-modal";
import {SendSignalService} from "../../../../_services/send-signal.service";
import {AlertBoxComponent} from "../../../../_common/alert-box/alert-box.component";

@Component({
    selector: 'app-popup-manage-coin-in-cmc',
    templateUrl: './popup-manage-coin-in-cmc.component.html',
    styleUrls: ['../../send-signal-event.component.css']
})
export class PopupManageCoinInCmcComponent extends DialogComponent<CoinModelSendSignal, boolean> implements OnInit {

    constructor(dialogService: DialogService, private sendSignalService: SendSignalService,) {
        super(dialogService);
    }

    loading = false;
    isFromValidate: boolean = false;
    coinName: any;
    otherCoinName: any;
    otherCoinNameClone: any = '';
    btnSaveOrUpdate: any;
    data: any;
    titlePopup: string;
    errorMessage: string = '';

    ngOnInit() {
        this.coinName = this.coinName;
        this.otherCoinName = this.otherCoinNameClone = this.otherCoinName;
    }

    changeCoinNameCMC(event: any) {
        this.otherCoinNameClone = (event.target.value.toUpperCase() || '');
        this.errorMessage = '';
        if (this.otherCoinNameClone != this.otherCoinName && this.otherCoinNameClone.length) {
            this.isFromValidate = true;
        } else {
            this.isFromValidate = false;
        }
    }

    updateCoinNameCMC() {
        let self = this;
        self.loading = true;
        if (self.isFromValidate) {
            self.sendSignalService.postUpdateCoinNameCMC({
                coinName: self.coinName,
                coinNameCMC: self.otherCoinNameClone
            }).subscribe(resData => {
                self.loading = false;
                self.isFromValidate = false;
                if (resData.hasOwnProperty('result') && resData.result == false) {
                    if (resData.hasOwnProperty('type') && resData.type === '_FAIL_') {
                        if (resData.hasOwnProperty('error')) {
                            self.dialogService.addDialog(AlertBoxComponent, {message: resData.error}).subscribe((result) => {
                                self.close();
                            });
                        }
                    }
                } else if (resData.hasOwnProperty('result') && resData.result == true) {
                    if (resData.hasOwnProperty('type') && (resData.type === '_VALIDATE_')) {
                        self.errorMessage = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('coinName')) ? resData.error.errMessage[0] : '';
                        self.errorMessage = !self.errorMessage
                            ? (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('coinNameCMC')) ? resData.error.errMessage[0] : ''
                            : self.errorMessage;
                        self.errorMessage = !self.errorMessage
                            ? (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('errMessage')) ? resData.error.errMessage : ''
                            : self.errorMessage;

                    } else if (resData.hasOwnProperty('type') && (resData.type === '_SUCCESS_')) {
                        self.isFromValidate = true;
                        this.result = true;
                        self.close();
                    }
                }
            }, error => {
                self.isFromValidate = false;
            });
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/send-signal-event/manage-coin-in-cmc/popup-manage-coin-in-cmc/popup-manage-coin-in-cmc.component.ts